module.exports = __webpack_public_path__ + "media/success.18288d46.wav";